import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {DatePipe} from "@angular/common";
import {DateTimeService} from "../../services/date-time.service";

@Component({
    selector: 'app-committee-deal-dates',
    templateUrl: './committee-deal-dates.component.html',
    styleUrls: ['./committee-deal-dates.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CommitteeDealDatesComponent implements OnInit {
  constructor(public datePipe: DatePipe, public dateTimeService: DateTimeService) {
  }

  @Input() deal: any;
  keyTypes: Array<string> = ['Closing Deadline', 'Warehouse Funding Deadline', 'Direct Funding Deadline'];

  row1: Array<any> = [];
  ngOnInit() {

    for(let i = 0; i < this.deal.project.projectSubstatusDates.length; i++){
      let rowObj = {
        key: null,
        value: ""
      }
      if(this.keyTypes.includes(this.deal.project.projectSubstatusDates[i].substatus.name)){
        rowObj.key = this.deal.project.projectSubstatusDates[i].substatus.name
        rowObj.value = this.formatDate(this.deal.project.projectSubstatusDates[i]);
        this.row1.push(rowObj)
      }
    }
  }

  formatDate(substatusDate:any){
    let date = substatusDate.date
    let time = substatusDate.utc_time
    let timezone:any = this.dateTimeService.timezones.find((zone) => zone.tz == substatusDate.timezone)
    let newDate = new Date(date + " " + time + " " + "UTC")
    let isDST = this.dateTimeService.isDST(newDate)
    let dateString = this.datePipe.transform(newDate, 'MM/dd/yyyy h:mm a', isDST ? timezone.dstabbr : timezone.abbr)
    dateString = dateString + " " + timezone.abbr
    return dateString ?? ""
  }
}
